export default "__VITE_ASSET__Cj$enMt3__"